import React from 'react';
import './ReadyToBuySection.scss';

export function ReadyToBuySection({appConfig}) {
  const applyForCredit = () => {
    window.location.href = appConfig.ocaTarget;
  };
  return (
    <>
      <div className='prequal--web-ford-motion-ready-to-buy-section'>
        <div className='prequal--web-ford-motion-ready-to-buy-section-content'>
          <div className='prequal--web-ford-motion-ready-to-buy-image-container'>
            <div className='prequal--web-ford-motion-ready-to-buy-image' />
          </div>
          <div className='prequal--web-ford-motion-ready-to-buy-detail'>
            <span className='prequal--web-ford-motion-ready-to-buy-detail-text'>Ready To Buy?</span>
            <span className='prequal--web-ford-motion-ready-to-buy-detail-subtext'>
              Save time at the dealership by completing your Full Credit Application.
            </span>
            <div className='prequal--web-ford-motion-apply-for-credit-button-container'>
              <button
                data-testid='apply-for-financing'
                type='button'
                className='prequal--web--apply-for-credit-button'
                onClick={() => {
                  applyForCredit();
                }}
              >
                Apply For Credit
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
